module.exports = {
  fadeSlideInUp: {
    "0%": {
      opacity: "0",
      transform: "translateY(100%)",
    },
    "100%": {
      opacity: "1",
      transform: "translateY(0)",
    },
  },

  nudge: {
    "0%": {
      transform: "translateX(var(--nudge-delta-x-start))",
      backgroundColor: "var(--nudge-bg-start)",
      color: "var(--nudge-text-start)",
      opacity: "var(--nudge-opacity-start)",
    },
    "95%, 100%": {
      transform: "translateX(var(--nudge-delta-x-end))",
      backgroundColor: "var(--nudge-bg-end)",
      color: "var(--nudge-text-end)",
      opacity: "var(--nudge-opacity-end)",
    },
  },
}
